<template>
<section class="container list-page">
    <div >
        <!-- <a>Link</a> -->
         <Breadcrumb 
            :levelTwoText = "type == 'ridertags' ? 'Rider Tags' : 'Bicycle Travel Blogs'"
        
        />
        <Heading 
            :heading="type == 'ridertags' ? 'Rider Tags' : 'Bicycle Travel Blogs'"
        /> 


        <div v-if="links.length > 0">
                <div v-if="type == 'ridertags'">
                    When people submit their posts, they have the option to choose tags (or create new ones) to describe themselves or their bike. This list represents one 
                    small step in celebrating the diversity of our bike travel community. Click a tag to see the posts associated with it.
                </div>
                <div v-if="type == 'sites'">
                   A complete list of all the bicycle touring and bikepacking blogs included in the BikeSleepBike directory. <br>To add your own site or that of your favorite bike traveler, please <router-link to='/share'>submit posts here</router-link>.  
                </div>
                <div class="spacer" style="height:60px"></div>  

                <div style="max-width:500px; margin-left:auto; margin-right:auto">
                    <b-field label="Search:">
                        <b-input v-model="filterInput" placeholder='start typing...'></b-input>
                    </b-field>
                </div>

                <div class="spacer" style="height:60px"></div> 

                <ul>
                    <li  class="list-link" v-for="linkObj in links" v-bind:key="linkObj.id" v-bind:class="type + '-row'">
                        <div class="card" style="margin-bottom:25px; margin-left:auto; margin-right:auto; padding:20px;" 
                        v-if="linkObj.id != 'undefined' && ( ( filterInput != '' && getDisplayText(linkObj.id).toLowerCase().includes(filterInput.toLowerCase()) || filterInput == '' ) )">
                            <router-link v-bind:to="'/' + type + '/' + getDisplayText(linkObj.id)">
                            <div class="columns is-mobile is-vcentered">
                                <div class="column has-text-left ">
                                    <router-link class="is-size-5 is-size-6-mobile title" style="display:inline-block; margin-bottom:0px" v-bind:to="'/' + type + '/' + getDisplayText(linkObj.id)">{{linkObj.id}}</router-link>

                                
                                </div>
                                <div class="column has-text-right is-narrow">
                                    <div class="columns is-mobile">
                                    <div class="column is-narrow">
                                        <div class="small-label">Posts</div>
                                        <p>{{linkObj.post_count}}</p>
                                    </div>
                                    
                                    
                                    </div>
                                </div>

                            </div>
                            
                            </router-link>
                        </div>
                    </li>
                </ul>
            <!-- </div> -->

        </div>
        <!-- <pre>{{type}}</pre> -->
        <div class="section card" ref="results" v-if="isLoading">
            <b-icon class="fas fa-spinner fa-spin"></b-icon>
            Loading...
        </div>
        
        <div class="spacer" style="height:100px"></div>



    </div>
    </section>
</template>

<script>
import Heading from '@/components/Heading';
import Breadcrumb from '@/components/Breadcrumb';
// import Book from '@/components/Book';

export default {
  name: 'RidertagsAndSites',
  props: ['type'],
  components: {  Heading, Breadcrumb },
  data () {
    return {
        links: [],
        filterInput: "",
        // routesData: [],
        orderby: 'posts',
        isLoading: false,
        
        // selectedContinent: "All",
        singularMap: { countries: "country", routes: "route", sites: "blog", ridertags: "rider tag", continents: "continent" },
        displayTextMap: { Transamerica: "TransAmerica" , 'Pan-american Highway': "Pan-American Highway"} // copied from findTrip
        // type: this.type
    }
  },
  computed: {
    sortedRows() {
        if (this.orderby == 'posts') {
            return [...this.links].sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
        } else {
            return [...this.links].sort((a, b) => (this.$countrymap[a.id] > this.$countrymap[b.id]) ? 1 : -1);
        }
    }
  },
//   metaInfo() {
    
//         return {
//             title: '**** Browse | Bike Sleep Bike',
//             description: "Find bike travel blogs"
            
//         }
//     },
  methods: {
   
      getDisplayText(val) {
          if (this.displayTextMap[val]) {
              return this.displayTextMap[val];
          } else {
              return val;
          }

      },
      displayMapping(type) {
          if (type == 'ridertags') {
              return "rider tags";
          } else if (type == "sites") {
              return "blogs";
          }
      },
      comparePostCount(a, b) {
        //   console.log(a);
          if (a.post_count > b.post_count) {return -1; }
          if (a.post_count < b.post_count) {return 1; }
          return 0;
      },
      titleCase(str) {
        //   console.log(str);
            str = str.toLowerCase();
            str = str.split(' ');
            for (var i = 0; i < str.length; i++) {
                str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
          
            }
            return str.join(' ');
        },
        getLinks() {
            // this.type = this.$route.params.type;
            this.links = [];
            var result = [];
            var that = this;
            this.isLoading = true;
            this.$db.collection("page_counts").doc(this.type).get()
            .then(function(doc) {
                if (doc.exists) {
                    for (const linkProp in doc.data()) {
                    
                        const dataObj = doc.data()[linkProp];
                        dataObj.id = linkProp;
                        result.push(dataObj);
                    }
                    result = result.sort(that.comparePostCount);
                    that.links = result;
                    that.isLoading = false;
                        // that.links = doc.data();
                } else {
                    console.log("ERROR: Can't fetch post counts for " + this.type);
                    that.isLoading = false;
                }
            })
            .catch(function(error) {
                console.log("Error getting " + this.type + ": ", error);
                that.isLoading = false;
            });

        },
        
  
  },
   metaInfo() {
        var title =  this.titleCase(this.displayMapping(this.type));
        var description = "Browse " + title + " at BikeSleepBike, a directory of bicycle touring and bikepacking blogs from all over the world.";
        return {
            title: title,
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com/" + this.type}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    

  },
  beforeRouteEnter(to, from, next) {
      next(component => {
        //   if (component.type == 'routes') {
            //   component.getRoutes();
        //   } else {
              component.getLinks();
        //   }
          
      })
  },
  beforeRouteChange(to, from, next) {
    //   if (this.type == 'routes') {
        //   this.getRoutes();
    //   } else {
        this.getLinks();
        // console.log("mounted");
    //   }
      
  },
  mounted() {
    // this.type = this.$route.params.type;
    this.getLinks(); //ADDED FOR REWRITES
    // if (this.type == "routes") {
    //     this.getRoutes();
    // }
    // console.log("mounted");
  },
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .list-link {
        margin-bottom:10px;
        font-size: 1.1em;
    }
    /* .ridertag-row {
        padding: 30px;
        background-color: white;
    } */
    .list-link .card a {
        color:black;
    }
    .ridertags-row {
        max-width:500px;
        margin-left:auto;
        margin-right:auto;
    }
    .sites-row {
        max-width:800px;
        margin-left:auto;
        margin-right:auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/RidertagsAndSites.vue